<template>
  <div>
    <h2 style="margin-bottom: -1px !important;text-align:center">{{institue.Name}}</h2>
    <table>
      <thead>
        <tr>
          <th>
            <table style="font-size:13px">
              <tr>
                <td style="width: 20%">
                  <img v-bind:src="img.Image" style="width: 35%" />
                </td>
                <td style="width: 60%; vertical-align: top; font-size: 13px">
                  <br />
                  <br />
                  <label style="font-size: 13px">Academic Transcript</label>
                  <br />
                  <label style="font-size: 13px">{{student.department}}</label>
                  <br />
                  <label style="font-size: 13px">{{student.program}}</label>
                </td>
                <td style="width: 20%">
                  <img v-bind:src="student.Image" style="width:35%" />
                </td>
              </tr>
              <tr>
                <td colspan="3" style="font-size:12px">
                  <table>
                    <tr>
                      <td width="33.3%" align="left" style="font-size:12px">Name: {{student.Name}}</td>
                      <td width="33.3%" style="font-size:12px"></td>
                      <td width="33.3%" align="left" style="font-size:12px">Reg. No. :{{student.RegistrationNo}}</td>
                    </tr>
                    <tr>
                      <td width="33.3%" align="left" style="font-size:12px">Father's Name:{{student.FathersName}}</td>
                      <td width="33.3%" style="font-size:12px"></td>
                      <td width="33.3%" align="left" style="font-size:12px">Roll No:{{student.RollNo}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td colspan="3" align="center" style="font-size:12px;">
                  <i>NOTE: This transcript is not official</i>
                </td>
              </tr>
              <tr>
                <td colspan="3" align="left" style="font-size:12px">
                  She has secured the marks as detailed below:
                </td>
              </tr>
            </table>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" style="font-size:10px">
              <thead>
                <tr> 
                  <th width="15%">Code Code</th>
                  <th width="35%">Course Name</th>
                  <th width="10%">T.Marks</th>
                  <th width="10%">Obt.Marks</th>
                  <th width="10%">Cr.Hrs.</th>
                  <th width="10%">GP</th>
                  <th width="10%">Grade</th>
                </tr>
              </thead>
            </table>
            <div v-for="(item,index) in data">
              <table border="1" style="font-size:10px">
                <tbody>
                  <tr>
                    <td colspan="7" align="center" style="font-weight:bold; font-size:10px;">Semester - {{item.Name}}</td>
                  </tr>
                  <tr v-for="(item2,ind) in item.child"> 
                    <td width="15%">{{item2.Code}}</td>
                    <td width="35%">{{item2.Course}}</td>
                    <td width="10%" align="center">{{getCourseTotalMarks(item2.ActiveSemesterID, item2.RoadMapCourseID)}}</td>
                    <td width="10%" align="center">{{item2.MarksObtained.toFixed(2)}}</td>
                    <td width="10%" align="center">{{item2.CreditHours}}</td>
                    <td width="10%" align="center">{{getGP(item2.RoadMapCourseID,item2.MarksObtained,item.ActiveSemesterID,ind)}}</td>
                    <td width="10%" align="center">{{getGrade(item2.MarksObtained, item2.ActiveSemesterID, item2.RoadMapCourseID)}}</td>
                  </tr>
                  <tr>
                    <td colspan="2" style="font-weight:bold">Total Credit Hours {{getc(item.ActiveSemesterID)}}</td>
                    <td style="font-weight:bold" align="center">{{gettotalmarks(item.ActiveSemesterID)}}</td>
                    <td style="font-weight:bold" align="center">{{getobtainedmarks(item.ActiveSemesterID).toFixed(2)}}</td>
                    <td colspan="3" style="font-weight:bold" align="center">GPA : {{getGPA(item.ActiveSemesterID)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <table border="1" style="font-size:10px">
              <tr>
                <td width="50%" style="font-weight:bold"> Total Credit Hours Studied : {{totalcredithourss(3)}}</td>
                <td width="10%" style="font-weight:bold" align="center">{{totalllllmarks(3)}}</td>
                <td width="10%" style="font-weight:bold" align="center">{{obtainedmarkss(3).toFixed(2)}}</td>
                <td width="30%" style="font-weight:bold" align="center">CGPA :{{getcgpa(2)}}</td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>



<script>

  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        rollno: '', img: '', student: '', session: '',
        totalmarks: [],
        grade: [],
        institue: {},
      } 
    },

    created: function () {
      this.getprint();
    },

    methods: {
      getCourseTotalMarks(sem, crs) {
        var o = this.totalmarks.find(x => x.ActiveSemesterID == sem && x.RoadMapCourseID == crs);
        if (o == null) {
          return "0";
        }
        else {
          return o.TotalMarks;
        }
      },
      getGrade(marks, sem, crs) { 
        var total = this.totalmarks.find(x => x.ActiveSemesterID == sem && x.RoadMapCourseID == crs);
        if (total == null) {
          return "-";
        }
        else {
          var per = ((marks * 100) / total.TotalMarks).toFixed(2);
          var grade = this.grade.find(x => x.MarksFrom <= per && x.MarksTo >= per);
          if (grade != null) {
            return grade.Grade;
          }
          else
            return "--";
        }
      },


      getprint: function () {
        var vm = this;
        axios.post('/api/DCApi/gettranscriptreport')
          .then(function (response) {
            vm.data = response.data["result"];
            vm.session = response.data["session"];
            vm.student = response.data["st"];
            vm.img = response.data["institue"];
            vm.institue = response.data["institue"];
            vm.totalmarks = response.data["totalMarks"];
            vm.grade = response.data["grade"];

          })
          .catch(function (error) {
            console.log(error);
          });
      },
      obtainedmarkss(ID) {

        var totalcredithours = 0;

        for (var v in this.data) {

          totalcredithours += this.data[v].ObtainedMarks;

        }
        return totalcredithours;
      },
      totalllllmarks(ID) {

        var totalmarks = 0;

        for (var v in this.totalmarks) {
          totalmarks += this.totalmarks[v].TotalMarks;
        }
        return totalmarks;
      },
      totalcredithourss(ID) {
        var totalcredithours = 0;

        for (var v in this.data) {
          totalcredithours += this.data[v].CreditHours;
        }
        return totalcredithours;
      },
      getcgpa(id) {
        var totalcredithours = 0;
        var totalgps = 0;
        for (var v in this.data) {

          totalcredithours += this.data[v].CreditHours;

        }
        for (var v in this.data) {
          totalgps += this.data[v].GPA * this.data[v].CreditHours;
        }
        var total = totalgps / totalcredithours;
        return total.toFixed(2);
      },
      getGPA(ID) { 
        var totalcredithours = 0;
        var totalgps = 0;
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            for (var s in this.data[v].child) {
              totalcredithours += this.data[v].child[s].CreditHours;
            }
          }
        }
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            for (var s in this.data[v].child) {
              totalgps += this.data[v].child[s].CreditHours * this.data[v].child[s].GP;
            }
          }
        }
        var total = (totalgps / totalcredithours).toFixed(2);
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            this.data[v].GPA = parseFloat(total);
          }
        }


        return total;

      },
      getobtainedmarks(ID) {
        var totalmarks = 0;
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            for (var s in this.data[v].child) {
              totalmarks += this.data[v].child[s].MarksObtained;
            }
          }
        }
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            this.data[v].ObtainedMarks = totalmarks;
          }
        }
        return totalmarks;
      },
      gettotalmarks(ID) {
        var totalmarks = 0;

        this.totalmarks.filter((x) => { return x.ActiveSemesterID == ID; }).forEach(function (item) {
          totalmarks = totalmarks + item.TotalMarks;
        });

        return totalmarks;
      },
      getc(ID) {
        var totalcredithours = 0;
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            for (var s in this.data[v].child) {
              totalcredithours += this.data[v].child[s].CreditHours;
            }
          }
        }
        for (var v in this.data) {
          if (this.data[v].ActiveSemesterID == ID) {
            this.data[v].CreditHours = totalcredithours;
          }
        }
        return totalcredithours;

      },
      getGP(crs, obt, ActiveID, index) {
        var total = this.totalmarks.find(x => x.RoadMapCourseID == crs && x.ActiveSemesterID == ActiveID);

        var result = 0;
        if (total != null)
          result = Math.round(((obt * 100) / total.TotalMarks));
        var obj = this.data.find(x => x.ActiveSemesterID == ActiveID);
        if (result >= 85) {
          var t = 4.00;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 84 && result < 85) {
          var t = 3.90;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 83 && result < 84) {
          var t = 3.80;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 82 && result < 83) {
          var t = 3.80;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 81 && result < 82) {
          var t = 3.70;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 80 && result < 81) {
          var t = 3.70;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 79 && result < 80) {
          var t = 3.60;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 78 && result < 79) {
          var t = 3.60;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 77 && result < 78) {
          var t = 3.50;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 76 && result < 77) {
          var t = 3.40;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 75 && result < 76) {
          var t = 3.30;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 74 && result < 75) {
          var t = 3.20;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 73 && result < 74) {
          var t = 3.20;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 72 && result < 73) {
          var t = 3.10;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 71 && result < 72) {
          var t = 3.10;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 70 && result < 71) {
          var t = 3.00;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 69 && result < 70) {
          var t = 3.00;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 68 && result < 69) {
          var t = 2.90;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 67 && result < 68) {
          var t = 2.80;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 66 && result < 67) {
          var t = 2.80;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 65 && result < 66) {
          var t = 2.70;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 64 && result < 65) {
          var t = 2.60;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 63 && result < 64) {
          var t = 2.60;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 62 && result < 63) {
          var t = 2.50;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 61 && result < 62) {
          var t = 2.40;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 60 && result < 61) {
          var t = 2.30;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 59 && result < 60) {
          var t = 2.20;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 58 && result < 59) {
          var t = 2.20;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 57 && result < 58) {
          var t = 2.10;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 56 && result < 57) {
          var t = 2.10;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 55 && result < 56) {
          var t = 2.00;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 54 && result < 55) {
          var t = 1.90;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 53 && result < 54) {
          var t = 1.80;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 52 && result < 53) {
          var t = 1.80;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 51 && result < 52) {
          var t = 1.70;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result >= 50 && result < 51) {
          var t = 1.00;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
        else if (result < 50) {
          var t = 0.00;
          for (var v in this.data) {
            if (this.data[v].ActiveSemesterID == ActiveID) {
              this.data[v].child[index].GP = t;
            }
          }
          return t.toFixed(2);
        }
      },
    }
  });
</script>
<style>

  tr th {
    text-align: center;
    color: black;
  }

  table {
    width: 100%;
    border-color: black;
    border-collapse: collapse;
  }

  td table tr th {
    background-color: lightgray;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/DC/transcriptPrint.vue